import { useQuery } from '@tanstack/react-query';
import { allocationTagQueries } from '../queries';
import type { AllocationTagFilters } from '../types/AllocationTag';

export function useAllocationTags(filters: AllocationTagFilters) {
  return useQuery(allocationTagQueries.list(filters));
}
